import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import NewsProvider, { useNews } from 'contexts/news'
import { useLocationStateIntent, useLocationQueryIntent } from 'hooks/location-intent'
import { Navigate } from 'react-router-dom'
import { getNewsArticleUrl } from 'utilities/url'
import { ActionColumn } from './s'
import { Ghost } from 'components/button'

const AddArticle = () => {
    const [adding, setAdding] = useState(false)
    const [added, setAdded] = useState(null)

    const newsContext = useNews()

    const addArticle = async () => {
        setAdding(true)
        const { ok, response } = await newsContext.addArticle()
        setAdding(false)

        if(ok && response) {
            setAdded(response)
        }
    }

    useLocationStateIntent({
        intent: 'add-article',
        action: addArticle
    })

    useLocationQueryIntent({
        intent: 'add',
        action: addArticle
    })

    if(added) {
        return (
            <Navigate
                to={getNewsArticleUrl({
                    ...added,
                    mode: 'edit'
                })}
                replace />
        )
    }

    return (
        <ActionColumn>
            <Ghost
                onClick={addArticle}
                className={`constructive${adding ? ' loading' : ''}`}>
                <FormattedMessage
                    id="news_action_create"
                    defaultMessage="New article" />
            </Ghost>
        </ActionColumn>
    )
}


export default props => (
    <NewsProvider articles={[]}>
        <AddArticle {...props} />
    </NewsProvider>
)
